<template lang="html">
  <li @click="gotoOrderDetail(item)">
    <CellSwipe
      :right="[
        {
          content: '删除',
          style: {
            background: '#FE3B30',
            color: '#fff',
            display: 'flex',
            alignItems: 'center',
            borderRadius: '0 16px 16px 0'
          },
          handler: () => deleteSection(index, item)
        }
      ]"
    >
      <div>
        <div class="shareListItemTitle">
          <img src="../../assets/images/order/icon-store.png" alt="" />
          <div class="name">{{ item.businessName }}</div>
        </div>
        <div class="shareListItemInfo">
          <img :src="item.cmmdtyImage | avatar(250, 150)" />
          <div class="info">
            <div class="infoTitle">
              {{ item.spuName }}
            </div>
            <div class="infoOption">
              <p class="spu-price" v-if="item.minPrice === item.maxPrice">
                <i>&yen;</i>{{ item.minPrice / 100 }}
                <span v-html="getEarn(item)"></span>
              </p>
              <p class="spu-price" v-else>
                <i>&yen;</i>{{ item.minPrice / 100 }}-<i>&yen;</i
                >{{ item.maxPrice / 100 }} <span v-html="getEarn(item)"></span>
              </p>
              <img src="../../assets/images/newShare/icon-share.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </CellSwipe>
  </li>
</template>

<script>
import { CellSwipe } from 'mint-ui'
import { Msgbox } from 'kf-component-vue'

export default {
  props: {
    item: {
      type: Object,
      default() {
        return {}
      }
    },
    index: {
      type: Number,
      default: null
    }
  },
  data() {
    return {}
  },
  methods: {
    getEarn(item) {
      if (item.minSaleRate == null || item.minSaleRate == null) {
        return ''
      }
      if (item.minSaleRate == item.maxSaleRate) {
        return `赚&yen;${item.minSaleRate / 100}`
      } else {
        return `赚&yen;${item.minSaleRate / 100}-&yen;${item.maxSaleRate / 100}`
      }
    },
    gotoOrderDetail(item) {
      location.href = `//life.cekid.com/v/product/${item.spuId}?skuId=${
        item.skuId || ''
      }&ruleId=${item.ruleId || ''}&ruleType=${item.ruleType || ''}`
    },
    deleteSection(index, item) {
      Msgbox({
        title: '确认删除？',
        message: '',
        showCancelButton: true,
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'confirm',
        action: msgbox => {
          this.deleteItem(index, item)
        },
        cancel: msgbox => {}
      })
    },
    async deleteItem(index, item) {
      const { uid } = await this.$$ensureLogin()
      const params = {
        uid,
        spuIds: [item.spuId]
      }
      const res = await this.$store.dispatch('deleteChecklistBySpuId', params)
      if (res && +res.code == 1) {
        this.$emit('operation', index)
        this.$$toast('删除成功')
      }
    }
  },
  computed: {},
  components: {
    CellSwipe,
    Msgbox
  }
}
</script>
<style lang="scss">
.mint-cell {
  border-radius: 16px !important;
}

.mint-cell-wrapper {
  background-image: none !important;
  border-radius: rem(16px) !important;
}

.mint-cell:last-child {
  background-image: none !important;
}
</style>

<style lang="scss" scoped>
@import '../../assets/css/mixin';
li {
  display: block;
  // padding: rem(30px) rem(24px) rem(30px);
  // background: #ffffff;
  margin: rem(20px) rem(24px) 0;
  // border-radius: rem(16px);

  .shareListItemTitle {
    height: rem(92px);
    width: rem(662px);
    display: flex;
    align-items: center;
    padding: 0 rem(4px);

    img {
      display: block;
      width: rem(30px);
      height: rem(30px);
      // border-radius: 50%;
    }

    .name {
      font-size: rem(26px);
      color: #262626;
      line-height: rem(30px);
      font-weight: bold;
      margin-left: rem(10px);
    }
  }

  .shareListItemInfo {
    display: flex;
    justify-content: center;
    width: rem(662px);
    padding: 0 rem(4px) rem(30px);

    img {
      display: block;
      width: rem(230px);
      height: rem(138px);
      border-radius: rem(16px);
    }

    .info {
      flex: 1;
      margin-left: rem(20px);
      display: flex;
      justify-content: space-between;
      flex-direction: column;

      .infoTitle {
        width: rem(384px);
        max-height: rem(78px);
        color: #121212;
        font-size: rem(28px);
        font-weight: bold;
        word-break: break-all;
        text-align: left;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        text-overflow: ellipsis;
        display: -webkit-box;
        line-height: rem(38px);
        overflow: hidden;
      }
      .infoOption {
        height: rem(54px);
        display: flex;
        align-items: center;
        justify-content: space-between;

        .spu-price {
          padding-top: rem(16px);
          font-size: rem(32px);
          font-weight: 700;
          margin-right: rem(10px);
          color: #ff397e;
          line-height: rem(45px);

          i {
            font-size: rem(24px);
            font-weight: normal;
          }

          span {
            font-size: rem(26px);
            color: #ff6d00;
            padding-left: rem(8px);
            font-weight: normal;
          }
        }

        img {
          display: block;
          width: rem(54px);
          height: rem(54px);
          border-radius: 50%;
        }
      }
    }
  }
}
</style>
